import React from "react";
import { motion, useInView } from "framer-motion";
import { Link } from "react-router-dom";
import "./Home.scss"; // Import your custom CSS for styling

import About from "../../Pages/About/About";
import Ourservices from "../../Pages/Ourservices/Ourservices";
import dummyimg from '../../Pages/images/transport.jpg'

import homeBannerImg from "../../Pages/images/home-banner.webp";
import HomeHero from "./HomeHeroSection";
import HowItWorks from "./HowItWorks";
import WhyItWorks from "./WhyItWorks";
import YourContainer from "./YourContainer";


const Home = () => {

  // Define the animation variants
  const baseVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const leftVariants = {
    hidden: { opacity: 0, x: -100 }, // Start off-screen to the left
    visible: { opacity: 1, x: 0 }, // Move to its original position
  };

  const Section = ({ children, isLeft }) => {
    const ref = React.useRef(null);
    const isInView = useInView(ref, { once: false });

    return (
      <motion.div
        ref={ref}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={isLeft ? leftVariants : baseVariants}
        transition={{ duration: 1.25, ease: "easeInOut" }}
        className="scroll-section"
      >
        {children}
      </motion.div>
    );
  };

  return (
    <>
      <HomeHero />
      <HowItWorks />
      <WhyItWorks />
      <YourContainer />
    </>
  );
};

export default Home;
